module.exports = __webpack_public_path__ + "img/03.4a91b8a3.jpg";